<app-header-style-two></app-header-style-two>

<div class="page-title-area page-title-style-two item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/">Accueil</a></li>
                <li>Offres</li>
            </ul>
            <h2>Nos offres</h2>
        </div>
    </div>
</div>

<div class="courses-area ptb-100">
    <div class="container" *ngIf="offres.length === 0; else showOffreIn">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="row justify-content-center">
                    <div class="col-6 ">
                        <img src="../../../../assets/images/em/empty_offers2.jpg" alt="" srcset="">
                    </div>
                </div>
            </div>
           <div class="col-12 text-center">
            <div class="row justify-content-center">
                <div class="col-6">
                    <b>AUCUNE OFFRES DISPONIBLE</b>
                </div>
            </div>
           </div>
        </div>
    </div>
    <div class="container" *ngIf="loading">
        <div class="row justify-content-center">
            <div class="col-6 text-center">
                
                <span>Chargement...</span>
            </div>
        </div>
    </div>
    <ng-template #showOffreIn>
        <div class="container">
            <div class="courses-topbar">
                <div class="row align-items-center">
                    <div class="col-lg-4 col-md-4">
                        <div class="topbar-result-count">
                            <p>Offre(s) 1 – {{ offres.length }} sur {{ offres.length }}</p>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-8">
                        <div class="topbar-ordering-and-search">
                            <!-- <div class="row align-items-center">
                                <div class="col-lg-3 col-md-5 offset-lg-4 offset-md-1 col-sm-6">
                                    <div class="topbar-ordering">
                                        <select class="form-select">
                                            <option>Toutes</option>
                                            <option>En cours</option>
                                            <option>A venir</option>
                                            <option>Privée</option>
                                            <option>Public</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-5 col-md-6 col-sm-6">
                                    <div class="topbar-search">
                                        <form>
                                            <label><i class="bx bx-search"></i></label>
                                            <input type="text" class="input-search" placeholder="Rechercher une offre...">
                                        </form>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let item of offres" class="col-lg-4 col-md-6">
                    <div class="single-courses-box mb-30">
                        <div class="courses-image">
                            <a routerLink="/single-courses" class="d-block"><img src="assets/img/bg.jpg" alt="image"></a>
                            <div class="courses-tag">
                                <a routerLink="/courses-3-columns-style-1" class="d-block">{{item.offreService.offre.typeOffre.nom}}</a>
                            </div>
                        </div>
                        <div class="courses-content">
                            <!-- <div class="course-author d-flex align-items-center">
                                <img src="assets/img/user1.jpg" class="rounded-circle mr-2" alt="image">
                                <span>Steven Smith</span>
                            </div> -->
                            <h3><a routerLink="/single-courses" class="d-inline-block">{{item.offreService.offre.nom}}</a></h3>
                            <div class="courses-rating text-center">
                                <span>
                                    Du <span class="cl-date">{{item.dateDebut | date: "dd-MMMM-yyyy"}}</span> au <span class="cl-date">{{item.dateFin | date: "dd-MMMM-yyyy"}}</span>
                                </span>
                                <!-- <div class="review-stars-rated">
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                </div>
                                <div class="rating-total">
                                    5.0 (1 rating)
                                </div> -->
                            </div>
                        </div>
                        <div class="courses-box-footer">
                            <ul>
                                <li class="students-number">
                                    <i class='bx bx-map'></i> {{item.offreService.service.nom}}
                                </li>
                                <li class="courses-lesson">
                                    <!-- <i class='bx bx-book-open'></i>  -->
                                </li>
                                <li *ngIf="!item.prive" class="courses-price courses-price-c1">
                                    Public
                                </li>
                                <li *ngIf="item.prive" class="courses-price courses-price-c2">
                                    Privée
                                </li>
                            </ul>
                        </div>
                        <div class="overlay">
                            <div class="text">
                                <!-- <span *ngIf="item.offreService.offre.description.length <= 70" >{{item.offreService.offre.description.slice(0, 70)}}</span>
                                <span *ngIf="item.offreService.offre.description.length > 70">{{item.offreService.offre.description.slice(0, 70)}}...</span> -->
                                <span>{{item.offreService.offre.description}}</span>
                            </div>
                          </div>
                    </div>
                </div>
                
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="pagination-area text-center">
                        <span class="page-numbers current" aria-current="page">1</span>
                        <a routerLink="/courses-3-columns-style-1" class="page-numbers">2</a>
                        <a routerLink="/courses-3-columns-style-1" class="page-numbers">3</a>
                        <a routerLink="/courses-3-columns-style-1" class="page-numbers">4</a>
                        <a routerLink="/courses-3-columns-style-1" class="page-numbers">5</a>
                        <a routerLink="/courses-3-columns-style-1" class="next page-numbers"><i class='bx bx-chevron-right'></i></a>
                    </div>
                </div> -->
            </div>
        </div>
    </ng-template>
    
</div>